import { useTranslation } from 'react-i18next'

import { OpportunityForm as F } from '@percent/domain/volunteering'

export function MaxAttendeesField(props: Readonly<Omit<F.MaxAttendeesFieldProps, 'label' | 'placeholder'>>) {
  const { t } = useTranslation()

  return (
    <F.MaxAttendeesField
      {...props}
      label={t('volunteering.opportunity.form.common.attendeesSection.maxAttendeesField.label')}
      placeholder={t('volunteering.opportunity.form.common.attendeesSection.maxAttendeesField.placeholder')}
    />
  )
}
